import React from 'react';

// Styles & Assets
import styles from './MultiSelectButtons.module.css';

// Hooks
import { useTranslation } from 'react-i18next';

// Interfaces
interface Props {
    content: { id: number, content: JSX.Element | string }[]
    selectedIDs: number[]
    gridDisplay?: boolean
    onClick: (id: number) => void
}

const MultiSelectButtons: React.FC<Props> = ({ content, selectedIDs, gridDisplay = false, onClick }) => {

    const { t } = useTranslation();

    return (
        <>
            {content.length > 0 ?
                <div className={gridDisplay ? styles.buttonGridContainer : styles.buttonFiltersContainer}>
                    {content.map((contentItem) =>
                        <button
                            key={contentItem.id}
                            className={`${styles.buttonFilter} ${selectedIDs.some(id => id === contentItem.id) && styles.activeButtonFilter}`}
                            onClick={() => onClick(contentItem.id)}
                        >
                            {contentItem.content}
                        </button>
                    )}
                </div>
                :
                <p className={styles.noOptionsError}>{t('no_options_available')}</p>
            }
        </>
    );
};

export default MultiSelectButtons;